import { styled } from "styled-components";

const NotCorrelatedCell = styled.pre`
  color: ${({ theme }): string => theme.palette.gray[400]};
  font-family: ${({ theme }): string => theme.typography.type.primary};
  font-style: italic;
`;

export { NotCorrelatedCell };
